import { createContext, useEffect, useState } from 'react';

export const CustomCursorContext = createContext('default');

const CustomCursorProvider = ({ children }) => {
	const [typeCursor, setTypeCursor] = useState('default');
	useEffect(() => {
		setTypeCursor('default');
	}, []);
	return <CustomCursorContext.Provider value={{ typeCursor, setTypeCursor }}>{children}</CustomCursorContext.Provider>;
};

export default CustomCursorProvider;
